import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./styles/index.css";
import App from "@/app/App";
// import "./i18n";

// Global error handler to catch and display errors
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
  const container = document.getElementById("app");
  if (container && !container.querySelector('.error-display')) {
    container.innerHTML = `
      <div class="error-display" style="padding: 20px; font-family: sans-serif; max-width: 800px; margin: 0 auto;">
        <h1 style="color: #d32f2f;">Application Error</h1>
        <p><strong>Error:</strong> ${event.error?.message || 'Unknown error occurred'}</p>
        <details style="margin-top: 20px;">
          <summary style="cursor: pointer; color: #1976d2;">Show stack trace</summary>
          <pre style="background: #f5f5f5; padding: 10px; overflow: auto; margin-top: 10px; font-size: 12px;">
${event.error?.stack || 'No stack trace available'}
          </pre>
        </details>
      </div>
    `;
  }
});

// Unhandled promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

const container = document.getElementById("app");
if (!container) {
  throw new Error('Could not find root element with id="app"');
}

try {
  const root = createRoot(container);
  root.render(
    <Suspense fallback={<div style="padding: 20px; text-align: center;">Loading...</div>}>
      <App />
    </Suspense>
  );
} catch (error) {
  console.error('Failed to render app:', error);
  container.innerHTML = `
    <div class="error-display" style="padding: 20px; font-family: sans-serif; max-width: 800px; margin: 0 auto;">
      <h1 style="color: #d32f2f;">Failed to Load Application</h1>
      <p><strong>Error:</strong> ${error.message}</p>
      <details style="margin-top: 20px;">
        <summary style="cursor: pointer; color: #1976d2;">Show stack trace</summary>
        <pre style="background: #f5f5f5; padding: 10px; overflow: auto; margin-top: 10px; font-size: 12px;">
${error.stack}
        </pre>
      </details>
    </div>
  `;
}

